<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 200 200"
    style="enable-background: new 0 0 200 200"
    xml:space="preserve"
  >
    <rect style="fill: #ffffff" width="200" height="200" />
    <g id="Branding">
      <g
        id="Monogram-Dark-Background"
        transform="translate(-567.000000, -357.000000)"
      >
        <g id="Logo" transform="translate(564.000000, 357.000000)">
          <g id="Monogram" transform="translate(0.000000, 0.760305)">
            <path
              id="Combined-Shape-Copy"
              style="fill-rule: evenodd; clip-rule: evenodd; fill: #8e75ff"
              d="M107.5,121.1V96.6
					c0-1-0.5-1.5-1.5-1.5H81.5v-25H131c1,0,1.5,0.5,1.5,1.5v49.5H107.5z"
            />

            <path
              id="Rectangle-Copy-6"
              style="
                opacity: 0.405;
                fill-rule: evenodd;
                clip-rule: evenodd;
                fill: #8e75ff;
                enable-background: new;
              "
              d="
					M81.5,69.6v25H58c-0.5,0-0.5,0-0.5-0.5c0-0.5,0-0.5,0-0.5L81.5,69.6z"
            />

            <path
              id="Rectangle-Copy-7"
              style="
                opacity: 0.405;
                fill-rule: evenodd;
                clip-rule: evenodd;
                fill: #8e75ff;
                enable-background: new;
              "
              d="
					M107.5,144.1v-23.5h25l-24,24c-0.5,0.5-1,0.5-1,0C107.5,144.6,107.5,144.6,107.5,144.1z"
            />

            <path
              id="Rectangle-Copy-8"
              style="
                opacity: 0.405;
                fill-rule: evenodd;
                clip-rule: evenodd;
                fill: #8e75ff;
                enable-background: new;
              "
              d="
					M81.5,94.6h25c0.5,0,1,0.5,1,1v25H83c-1,0-1.5-0.5-1.5-1.5V94.6z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: "IconStrapi",
};
</script>
